export var sanitizeHtml = function (str) {
    if (!str)
        return '';
    return str.replace(/(<([^>]+)>)/gi, '');
};
